<template>
  <div v-if="$store.state.user.scope">
    <patient-view v-if="!isHcpView"></patient-view>
    <hcp-view v-if="isHcpView"></hcp-view>
  </div>
</template>
<script>
  import HCPMixin from '../../mixins/HCPMixin';
  import PatientView from "../../components/Dashboard/Views/Patient.vue";
  import HcpView from "../../components/Dashboard/Views/HCP.vue";
  export default {
    mixins: [
      HCPMixin
    ],
    components: {
      HcpView,
      PatientView
    },
    name: 'dashboard'
  }
</script>



// WEBPACK FOOTER //
// Dashboard.vue?44c6882b